// Foundation initialization
// This loads before main application to ensure Foundation is ready

// Import jQuery as module (Foundation needs it as a module)
import $ from 'jquery'

// Ensure jQuery is on window BEFORE importing jQuery UI (jQuery UI needs global jQuery)
window.$ = window.jQuery = $

// Import jQuery UI for sortable and other UI widgets
import 'jquery-ui-dist/jquery-ui'

// Import Foundation with jQuery integration
import Foundation from 'foundation-sites'

// Add Foundation utilities to jQuery
Foundation.addToJquery($)

// Make Foundation global
window.Foundation = Foundation

// Initialize Foundation on the document
$(document).foundation()

console.log('Foundation initialized with', Object.keys(Foundation.plugin))
